import { AbstractEntity } from './base/abstractEntity.model';
import { Element } from '@app/shared/model/entity/element.model';

export class Worklog extends AbstractEntity {
    id: number;
    action: string;
    comment: string;
    json: string;
    element: Element;
    elementRef: number;
}
